import { useRouter } from 'found';
import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../components/input/Button';
import FlatButton from '../../components/input/FlatButton';
import TextInput from '../../components/input/TextInput';
import Spacer from '../../components/Spacer';
import { HeadingNoMargin } from '../../components/typography/Typography';
import { routes } from '../../routes';
import { useToastDispatch } from '../../components/Toast/ToastProvider';
import { ScaleLoader } from 'react-spinners';
import LogoGradientIcon from '../../components/LogoGradientIcon';
import { makeMutation } from '../../api/helpers';
import { ResetPassword as ResetPasswordMutation } from '../../api/mutations';
import { HelpText } from '../../components/HelpText';

const Container = styled.div`
  width: 90vw;
  @media (min-width: 1200px) {
    width: 341px;
  }
`;

const LogoButton = styled.a`
  padding: 10px;
  display: inline-flex;
  border-radius: 5px;
  transition: all 0.2s;
  &:hover {
    background: #f4f5ff;
  }
`;

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const dispatch = useToastDispatch();
  const { router, match } = useRouter();

  let validToken = false;
  if (match.location.query?.['token']?.length ?? 0 > 1) {
    validToken = true;
  }

  const resetPassword = async () => {
    setLoading(true);

    try {
      await makeMutation(ResetPasswordMutation, {
        token: match.location.query?.['token'],
        password: password,
      });
    } catch (err) {}

    dispatch({ alert: 'success', text: 'Password successfully reset' });
    setLoading(false);

    setTimeout(() => {
      router.push(routes.login);
    }, 400);
  };

  const handleKey = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      resetPassword();
    }
  };

  return (
    <Container>
      <LogoButton href={'https://paypi.dev'}>
        <LogoGradientIcon />
      </LogoButton>
      <Spacer vertical spacing={2} />
      <HeadingNoMargin>Reset your password</HeadingNoMargin>
      <Spacer vertical spacing={3} />
      {validToken && (
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            resetPassword();
          }}
        >
          <TextInput
            label='NEW PASSWORD'
            fullWidth
            type={'password'}
            value={password}
            onKeyDown={(e) => handleKey(e)}
            onChange={setPassword}
          />
          <Spacer vertical spacing={3} />
          <Button color='white' onClick={() => resetPassword()}>
            {!loading && 'Reset password'}
            {loading && <ScaleLoader color={'#e4e4e6'} height={11} />}
          </Button>
          <input type='submit' hidden />
        </form>
      )}
      {!validToken && (
        <HelpText type='warning'>
          Reset token is invalid or not given. Go back to your reset email and
          click the link given.
        </HelpText>
      )}

      <Spacer vertical spacing={2} />
      <FlatButton
        darkenOnHover
        color='#5c6ef8'
        onClick={() => router.push(routes.login)}
      >
        Login
      </FlatButton>
    </Container>
  );
}

export default ResetPassword;
